/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/svenskdam/components/standalone/ArticleDisclosureLabel/theme';

export const ArticleDisclosureLabelTheme = theme;
